const initials = "homepage/";
export const UPDATE_MOBILE_HOMEPAGE_DATA = `${initials}UPDATE_MOBILE_HOMEPAGE_DATA`;
